module.exports = __webpack_public_path__ + "static/media/pro1.dc718368.jpg";